/* ===== Setup Forge — interações de scroll ===== */
(function () {
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Revela elementos suavemente conforme entram na tela */
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && !prefersReduced && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* Paralaxe leve em elementos marcados com data-speed */
  var parallaxEls = document.querySelectorAll('.js-parallax');
  if (parallaxEls.length && !prefersReduced) {
    var ticking = false;
    function updateParallax() {
      var y = window.scrollY || window.pageYOffset;
      parallaxEls.forEach(function (el) {
        var speed = parseFloat(el.dataset.speed || '0.15');
        el.style.transform = 'translateY(' + (y * speed) + 'px)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }, { passive: true });
    updateParallax();
  }

  /* Abas flutuantes de categoria (Setup Gamer / Peças de Computador) */
  var tabs = document.querySelectorAll('.cat-tab');
  var groups = document.querySelectorAll('.cat-group');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var target = tab.dataset.group;
      tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
      groups.forEach(function (g) {
        g.classList.toggle('is-active', g.dataset.group === target);
      });
    });
  });

  /* Header encolhe levemente depois de rolar */
  var header = document.querySelector('.sf-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-scrolled', window.scrollY > 40);
    }, { passive: true });
  }
})();
